/**
 * 通知收件箱主 tab 的切换判定。
 *
 * R-044 把 Announcement 从顶栏独立入口并进收件箱后主 tab 变成三个，但 Novu 那两个
 * tab 仍然由 `filters.archived` 布尔驱动（它被 list filter / setCurrentTab / 缓存
 * 有效性等十几处读取）。所以状态拆成两份：
 *   - mainTab —— 用户当前看到的 tab（含 announcements）
 *   - novuTab —— 最后停留的 Novu tab，announcements 期间**冻结不动**
 *
 * 冻结是关键：若让 archived 跟着 announcements 变，从 Archived 切到公告页会让
 * loadNotifications 的 effect 依赖变化，在后台白白重拉一次 Novu 列表。
 *
 * 另一个坑是回切：只比较 archived 的话，"announcements → inbox" 两边都是 false 会
 * 被当成 no-op —— 用户点 Inbox tab 没反应，永久卡在公告页。所以判定必须同时看目标
 * tab 和 novuTab 是否真的变了。
 *
 * 与 main-mobile 的 src/components/notifications/inboxMainTab.ts 同一份判定。
 */
export type InboxMainTab = 'inbox' | 'archived' | 'announcements'
export type InboxNovuTab = 'inbox' | 'archived'

export interface MainTabSwitch {
  /** 目标 tab 与当前不同 —— 需要 setMainTab。 */
  changed: boolean
  /** announcements 期间冻结成当前值。 */
  nextNovuTab: InboxNovuTab
  /** Novu 那侧真的翻页了 —— 需要重置分类筛选并重拉列表。 */
  reloadNotifications: boolean
}

export function resolveMainTabSwitch(
  currentMain: InboxMainTab,
  currentNovuTab: InboxNovuTab,
  target: InboxMainTab,
): MainTabSwitch {
  const nextNovuTab: InboxNovuTab = target === 'announcements' ? currentNovuTab : target
  const changed = currentMain !== target
  return {
    changed,
    nextNovuTab,
    reloadNotifications: changed && nextNovuTab !== currentNovuTab,
  }
}
